import * as React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../hooks/react-redux'
import useMyProfile from '../../../../../../../hooks/useMyProfile'
import {useSetUserProperty} from '../../../../../../../hooks/useSetUserProperty'
import {restApi} from '../../../../../../../services/rest'
import {UserProperties} from '../../../../../../../utils/userProperties'
import {feedbackForm} from '../Feedback.slice'

const formid = 'feedback/teamcity_pipelines'

export function useFeedbackFormModel() {
  const dispatch = useAppDispatch()
  const formData = useAppSelector(state => state.pipelines.feedbackForm.userInput)
  const user = useMyProfile()
  const setUserProperty = useSetUserProperty()
  const [send, sendResult] = restApi.endpoints.sendPipelinesFeedback.useMutation()

  const onSubmit = React.useCallback(() => {
    const name = user?.name ?? ''
    const email = user?.email ?? ''

    const rating = formData.rating
    const tags = formData.tags
    const comment = formData.comment

    const feedback = `
      Tags: ${tags.join(', ')}
      Comment: ${comment}
      `

    send({name, email, rating, feedback, formid})
    setUserProperty(UserProperties.HAS_SUBMITTED_PIPELINES_FEEDBACK_FORM, 'true')
  }, [
    formData.comment,
    formData.rating,
    formData.tags,
    send,
    setUserProperty,
    user?.email,
    user?.name,
  ])

  const onCancel = React.useCallback(() => {
    setUserProperty(UserProperties.HAS_SUBMITTED_PIPELINES_FEEDBACK_FORM, 'true')
    dispatch(feedbackForm.actions.setVisibility({visible: false}))
  }, [dispatch, setUserProperty])

  return {
    sendResult,
    onSubmit,
    onCancel,
  }
}
